type JsonPrimitive = string | number | boolean | null;

export interface JsonObject {
    [member: string]: JsonValue;
}

export type JsonValue = JsonPrimitive | JsonObject | Array<JsonValue>;

export interface InputData extends JsonObject {
    seqNum: number;
}

export enum BootstrapTheme {
    Standard = 'standard',
    Dark = 'dark',
}

export enum SgConnectEnvironment {
    Homologation = 'homologation',
    Production = 'production',
}

export interface SgDashboardProps {
    userSelection: JsonValue;
    // setUserSelection: (value: JsonValue) => void; // overridden in widgetize.ts'
    // emitEvent: (data: JsonObject) => void; // overridden in widgetize.ts by sending a CustomEvent '[widgetname]--value-updated'
    inputData: InputData | JsonObject; // inputDataProperty must be set to "inputData" in the metadata and eventWhenInputProcessed must be set to true
    logKey: string; // log identifier
    theme: BootstrapTheme;
    sgConnectEnvironment: SgConnectEnvironment;
}

export interface SgDashboardFilterProps extends SgDashboardProps {
    keyName: string;
}

export interface SgDashboardQueryParams {
    logKey: string;
    inputData: JsonObject;
    theme: BootstrapTheme;
    sgConnectEnvironment: SgConnectEnvironment;
}

type FilterItemKey = string;

export interface FilterItem {
    key: FilterItemKey; // used for the userSelection (i.e. persisted configuration). must be unique
    label: string;
    value: JsonValue; // used for the event
}


// SgDashboardArclabPicker

export type SgDashboardArclabPickerQuery = (params: SgDashboardArclabPickerQueryParams) => Promise<FilterItem[]>; // array length of FilterItem[] must be <= QueryParams.maxNbResults

export type SgDashboardArclabPickerQuerySelected = (params: SgDashboardArclabPickerQuerySelectedParams) => Promise<FilterItem[]>;

export interface SgDashboardArclabPickerQuerySelectedParams extends SgDashboardQueryParams {
    selected: FilterItemKey[];
}

export interface SgDashboardArclabPickerQueryParams extends SgDashboardQueryParams {
    search: string;
    maxNbResults?: number;
}

export interface SgDashboardArclabPickerProps extends SgDashboardFilterProps {
    query: SgDashboardArclabPickerQuery;
    querySelected: SgDashboardArclabPickerQuerySelected;
    maxNbResults?: number;
    placeholder?: string;
    icon?: string;
    keepSearchedText?: boolean;
    widgetAttributes: JsonObject | null;
    widgetProperties: JsonObject | null;
}

// SgDashboardArclabSelect

export type SgDashboardArclabSelectQuery = (params: SgDashboardArclabSelectQueryParams) => Promise<FilterItem[]>;
export interface SgDashboardArclabSelectQueryParams extends SgDashboardQueryParams {
  attributes: JsonObject | null;
  properties: JsonObject | null;
}


export interface SgDashboardArclabSelectProps extends SgDashboardFilterProps {
  query?: SgDashboardArclabSelectQuery;
  items?: string; // encodeURIComponent(JSON.stringify(json)) with 'json' of type Item[]
  withEmptyOption: boolean;
}

// SgDashboardArclabButtonGroup

export type SgDashboardArclabButtonGroupQuery = (params: SgDashboardArclabButtonGroupQueryParams) => Promise<FilterItem[]>;
export interface SgDashboardArclabButtonGroupQueryParams extends SgDashboardQueryParams {
  attributes: JsonObject | null;
  properties: JsonObject | null;
}


export interface SgDashboardArclabButtonGroupProps extends SgDashboardFilterProps {
  query?: SgDashboardArclabButtonGroupQuery;
  items?: string; // encodeURIComponent(JSON.stringify(json)) with 'json' of type Item[]
  resetable: boolean;
}

export interface SgDashboardArclabCheckboxProps extends SgDashboardFilterProps {
    label?: string;
}

